import {register} from '../../../JavaScript/Utils'

interface Entry {
  isIntersecting: boolean;
  [key: string]: any;
}

export const Kpi = (el: HTMLElement) => {
  const THRESHOLD = 0.5;
  const TIMEOUT_DURATION = 1;
  const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  const speed = 500;
  const counters = el.querySelectorAll('.js_kpi-card-numberfield');
  const formatter = new Intl.NumberFormat('de-DE', {notation: "compact", useGrouping: true})
  let animationHasStarted = false;

  const counter = () => {
    if(animationHasStarted) return;
    animationHasStarted = true;

    counters.forEach(counterEl => {
      if (counterEl instanceof HTMLElement) {
        let counter =  +counterEl.dataset.startvalue;

        const animate = () => {
          const endValue = +counterEl.dataset.endvalue;
          const time = endValue / speed;

          if (counter < endValue && !mediaQuery.matches) {
            counter = Math.ceil(counter + time);
            setTimeout(animate, TIMEOUT_DURATION);
          }
          else {
            counter = endValue
          }

          counterEl.innerText = formatter.format(counter);
        }

        animate();
      }
    });
  }

  // callback is called on intersection change
  const onIntersection = (entries: Entry[]): void => {
    entries.forEach(entry => {
        if (entry.isIntersecting) counter();
      }
    )
  }

  // define an observer instance
  const observer = new IntersectionObserver(onIntersection, {
    root: null,   // default is the viewport
    threshold: THRESHOLD // percentage of target's visible area. Triggers "onIntersection"
  })

// Use the observer to observe an element
  observer.observe( el )
};

register('Kpi', Kpi)
